import api from '$/io.ox/core/api/count'
import ox from '$/ox'

// DEPRECATED: `pe/count/api.js`, pending removal with 8.47.
if (ox.debug) console.warn('`pe/count/api.js` is deprecated, pending removal with 8.47. Please use `io.ox/core/api/count.js` directly')

export default api
